import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
    lineNo: {
        type: "number",
        name: "lineNo",
        label: "Line No",
        errorMsg: "Line No is required.",
        required: true,
        disabled: true
    },
    packageID: {
        type: "text",
        name: "packageID",
        label: "Package ID",
        maxLength: 20,
    },
    skuCode: {
        type: "select",
        name: "skuCode",
        label: "SKU Code",
        maxLength: 50,
        errorMsg: "SKU Code is required.",
        required: true,
        editable: false
    },
    vendorCode: {
        type: "select",
        name: "vendorCode",
        label: "Vendor Code",
        maxLength: 50,
        errorMsg: "Vendor Code is required.",
        required: true,
        editable: false
    },
    packType: {
        type: "text",
        name: "packType",
        label: "Pack Type",
        maxLength: 10,
        errorMsg: "Pack Type is required.",
        disabled: true,
        required: true
    },
    skuDescription: {
        type: "text",
        name: "skuDescription",
        label: "SKU Description",
        maxLength: 100,
    },
    mln: {
        type: "text",
        name: "mln",
        label: "MLN",
        maxLength: 20,
    },
    expiryDate: {
        type: "date",
        name: "expiryDate",
        label: "Expiry Date",
    },
    orderQty: {
        type: "number",
        name: "orderQty",
        label: "Order Qty",
        required: true,
    },
    orderUOM: {
        type: "select",
        name: "orderUOM",
        label: "Order UOM",
        maxLength: 10,
        required: true,
    },
    baseUOM: {
        type: "text",
        name: "baseUOM",
        label: "Base UOM",
        disabled: true
    },
    quantity: {
        type: "number",
        name: "quantity",
        label: "Quantity",
        errorMsg: "Please input Order Qty and Order UOM.",
        required: true,
        disabled: true
    },
    unitPrice: {
        type: "number",
        name: "unitPrice",
        label: "Unit Price",
        //prefix:"$"
    },
    currencyCode: {
        type: "text",
        name: "currencyCode",
        label: "Currency Code",
        maxLength: 10,
    },
    discountAmount: {
        type: "number",
        name: "discountAmount",
        label: "Discount Amount",
    },
    taxAmount: {
        type: "number",
        name: "taxAmount",
        label: "Tax Amount",
    },
    remark: {
        type: "text",
        name: "remark",
        label: "Remark",
        maxLength: 300,
    },
    orderShelfLife: {
        type: "number",
        name: "orderShelfLife",
        label: "Order Shelf Life",
    },
    status: {
        type: "text",
        name: "status",
        label: "Status",
        disabled: true
    },
};

const {
    lineNo, packageID, status, skuCode, vendorCode, packType, skuDescription, mln, expiryDate, orderQty, orderUOM, baseUOM, quantity, unitPrice, currencyCode, discountAmount, taxAmount, remark, orderShelfLife
} = formField;

export const detailRender = [
    [lineNo,vendorCode, status],
    [skuCode,packType,skuDescription, packageID],   
    [orderQty, orderUOM,baseUOM, quantity], 
    [unitPrice, currencyCode,discountAmount, taxAmount], 
    [mln, expiryDate,remark, orderShelfLife]
]

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
    [packageID.name]: Yup.string().nullable().max(packageID.maxLength),
    [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength).required(skuCode.errorMsg),
    [packType.name]: Yup.string().nullable().max(packType.maxLength).required(packType.errorMsg),
    [mln.name]: Yup.string().nullable().max(mln.maxLength),
    [expiryDate.name]: Yup.string().nullable(),
    [orderQty.name]: Yup.number().min(1, "Order Qty must be greater than 1").integer().required("Order Qty is required"),
    [orderUOM.name]: Yup.object().shape({ "value": Yup.string().nullable(), "label": Yup.string().nullable() }).nullable().required(),
    [quantity.name]: Yup.number().min(1, quantity.errorMsg).integer(),
    [unitPrice.name]: Yup.number().min(0),
    [currencyCode.name]: Yup.string().nullable().max(currencyCode.maxLength),
    [discountAmount.name]: Yup.number().min(0),
    [taxAmount.name]: Yup.number().min(0),
    [mln.name]: Yup.string().nullable().max(mln.maxLength),
    [remark.name]: Yup.string().nullable().max(remark.maxLength),
    [orderShelfLife.name]: Yup.number().min(0),
})